import { Component } from '@angular/core';
import { environment } from './../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false // NOSONAR
})
export class AppComponent {
	
	constructor() {
		console.info('Prod Environment:' + environment.production); // Logs false for default environment
	}
	
	title = 'Alarms UI';
}
